<mat-card style="background-color: #007749; text-align: center;"><h3 style="color: white">ELIMINAR AVERÍA</h3></mat-card>
        <mat-card style="height: 100%;">
                <div class="justify-content-center">
                    ¿Desea eliminar la Avería con VIN: <b>{{data.vin}}</b> ?    
                </div>
            <mat-card-actions>
                <div style="float: left; margin-top:30px">
                    <button mat-button class="buttontz" style="margin-left: 5px;" (click)="actualizarEstado(false)">Cancelar</button>
                </div>
                <div style="float: right; margin-top:30px">
                    <button mat-button class="buttontz" (click)="actualizarEstado(true)">Confirmar</button>
                </div>
            </mat-card-actions>
        </mat-card>